import React from "react";

import getSearchWidgetTranslations from "./searchWidgetTranslations"

import Icon from "src/components/icon";
import DatePicker from "src/components/aramon/datePicker";
import GuestPicker from "src/components/searchWidgetSection/guestPicker/guestPicker.skibig3";
import DateTime from "src/utils/temporalLuxonUtil";
import CTAButton from "src/components/ctabutton";
import { isRunTime } from "src/utils/isRunTime";

type TuruSearchWidgetTabProps = {
    tab: string;
    activeTab: string;
    onClick: any;
    icon: string;
    label: string;
    className: string;
}

class TuruSearchWidgetTab extends React.Component<TuruSearchWidgetTabProps> {
    render() {
        const active = this.props.activeTab == this.props.tab;
        return <>
            <button onClick={this.props.onClick} className={`${!active ? "bg-white/75" : "border-b-2 border-black"} bg-white p-4 flex-1 flex flex-col gap-2 items-center justify-center searchWidgetText md:min-h-[4rem]`}>
                <Icon width={26} height={26} icon={this.props.icon as any} color="#242426" />
                <span>{this.props.label}</span>
            </button>
        </>
    }
}


class TuruSearchWidgetTabs extends React.Component<{activeTab: string, setActiveTab: any, translations: any}> {
    setActiveTab(tab: string) {
        this.props.setActiveTab(tab);
    }

    render() {
        return <>
            <div className="flex rounded-t-2xl overflow-hidden h-[90px]">
                <TuruSearchWidgetTab className="" icon="Cabin2" label={this.props.translations.overnatting} tab="lodging" activeTab={this.props.activeTab} onClick={()=>this.setActiveTab('lodging')} />
                <TuruSearchWidgetTab className="" icon="Mountains" label={"Kjøp eiendom"} tab="eiendom" activeTab={this.props.activeTab} onClick={()=>this.setActiveTab('eiendom')} />
                {/*<TuruSearchWidgetTab className="" icon="LiftTicket" label={this.props.translations.seasonpass} tab="season-pass" activeTab={this.props.activeTab} onClick={()=>this.setActiveTab('season-pass')} />*/}
            </div>
        </>
    }
}


type TuruSearchWidgetLodgingProps = {
    startDate: Date;
    setStartDate: (date: Date) => void;
    endDate: Date;
    setEndDate: (date: Date) => void;
    minimumDate: Date;
    maximumDate: Date;
    selectedLanguage: string;
    defaultLanguage: string
}

type TuruSearchWidgetLodgingState = {
    adults: number;
    childs: number;
    smallScreen: boolean;
    childAges:{age: number}[][];
}

class TuruSearchWidgetLodging extends React.Component<TuruSearchWidgetLodgingProps, TuruSearchWidgetLodgingState> {
    state: TuruSearchWidgetLodgingState = {
        adults: 2,
        childs: 0,
        smallScreen: this.isSmall,
        childAges:[]
    }

    get link() {
        const lodgingSlug = "losji";
        let link = '/';
        if(this.props.defaultLanguage !== this.props.selectedLanguage) link += `${this.props.selectedLanguage}/`
        let childAges = this.state.childAges.map(childage => childage.map(c => c.age)).join(",");
        link += `${lodgingSlug}/?startdate=${this.startDate}&enddate=${this.endDate}&adult=${this.state.adults}&childages=${childAges}`;
        return link;
    }

    get startDate() {
        return DateTime.fromJSDate(this.props.startDate).toFormat("yyyy-MM-dd");
    }

    get minEndDate() {
        return DateTime.fromJSDate(this.props.startDate).plus({ day: 1 }).toJSDate();
    }

    get endDate() {
        return DateTime.fromJSDate(this.props.endDate).toFormat("yyyy-MM-dd");
    }

    get numNights() {
        const sd = DateTime.fromJSDate(this.props.startDate);
        const ed = DateTime.fromJSDate(this.props.endDate);
        const diff = sd.diff(ed, ["days"]);
        const numdays = Math.abs(diff.values.days)
        return numdays;
    }

    get isSmall() {
        if (isRunTime()) return window.innerWidth < 1024;
        return false;
    }

    onResize = () => {
        const isSm = this.isSmall;
        if (isSm !== this.state.smallScreen) {
            this.setState({smallScreen: isSm})
        }
    }
    componentDidMount() {
        window.addEventListener('resize', this.onResize);
        this.setState({smallScreen: this.isSmall});
    }
    componentWillUnmount(): void {
        window.removeEventListener('resize', this.onResize);
    }


    setGuests = ({childs, adults, childAges}:{childs:number[], adults:number[], childAges: {age: number}[][]}) => {
        this.setState({adults: adults[0], childs: childs[0], childAges});
    }

    render() {
        const {startDate, setStartDate, endDate, setEndDate} = this.props;
        const translations = getSearchWidgetTranslations(this.props.selectedLanguage);

        return <>
        <div className={`bg-white flex flex-col lg:flex-row gap-4 justify-between items-center p-4 sm:p-6 rounded-b-2xl`}>
            <div className="w-full lg:flex gap-4">
                <div className="w-full py-2 lg:py-0">
                    <DatePicker
                        label={translations.arrivalDate}
                        dateFormat="MMMM dd, yyyy"
                        onChange={setStartDate}
                        value={startDate}
                        openToDate={startDate}
                        showCalendarIcon={true}
                        locale={this.props.selectedLanguage}
                        includeDateIntervals={[{ start: this.props.minimumDate, end: this.props.maximumDate }]}
                    />
                </div>
                <div className="w-full py-2 lg:py-0">
                    <DatePicker
                        label={translations.departureDate}
                        dateFormat="MMMM dd, yyyy"
                        onChange={setEndDate}
                        value={endDate}
                        openToDate={endDate}
                        showCalendarIcon={true}
                        includeDateIntervals={[{ start: this.minEndDate, end: this.props.maximumDate }]}
                        locale={this.props.selectedLanguage}
                    />
                </div>
                <div className="hidden lg:flex w-full">
                    <GuestPicker withChildAges={true} onChange={this.setGuests} translations={translations} />
                </div>
                <div className="w-full lg:hidden">
                    <GuestPicker alwaysOpen={true} withChildAges={true} onChange={this.setGuests} translations={translations} />
                </div>
            </div>
            <div className="w-full lg:w-1/4">
                <CTAButton open_in_same_tab={true} link={this.link} color="#fff" bgcolor="#333" type="primary" text={translations.searchButton} icon={<Icon className="w-6 h-4" icon="ArrowRight" />} />
            </div>
          </div>
        </>
    }
}

type TuruSearchWidgetEiendomProps = {
    selectedLanguage: string;
    defaultLanguage: string
}

class TuruSearchWidgetEiendom extends React.Component<TuruSearchWidgetEiendomProps> {
    get link() {
        return "https://eiendom.turufjell.no/";
    }

    render() {
        return <>
        <div className={`bg-white flex flex-col lg:flex-row gap-4 justify-between items-center p-4 sm:p-6 rounded-b-2xl`}>
            <div className="ml-auto w-full lg:w-1/3">
                <CTAButton open_in_same_tab={true} link={this.link} color="#fff" bgcolor="#333" type="primary" text={"Se ledige tomter og hytter her"} icon={<Icon className="w-6 h-4" icon="ArrowRight" />} />
            </div>
        </div>
        </>
    }
}

type TuruSearchWidgetLiftTicketsProps = {
    startDate: Date;
    setStartDate: (date: Date) => void;
    minimumDate: Date;
    maximumDate: Date;
    selectedLanguage: string;
    defaultLanguage: string
}

class TuruSearchWidgetLiftTickets extends React.Component<TuruSearchWidgetLiftTicketsProps> {
    get link() {
        const ticketsSlug = "heiskort";
        let link = '/';
        if(this.props.defaultLanguage !== this.props.selectedLanguage) link += `${this.props.selectedLanguage}/`
        link += `${ticketsSlug}/?startdate=${this.startDate}`;
        return link;
    }

    get startDate() {
        return DateTime.fromJSDate(this.props.startDate).toFormat("yyyy-MM-dd");
    }

    render() {
        const {startDate, setStartDate, selectedLanguage} = this.props;
        const translations = getSearchWidgetTranslations(this.props.selectedLanguage);

        return <>
        <div className={`bg-white flex flex-col lg:flex-row gap-4 justify-between items-center p-4 sm:p-6 rounded-b-2xl`}>
            <div className="w-full lg:flex">
                <div className="w-full lg:w-2/4">
                    <DatePicker
                        label={translations.arrivalDate}
                        dateFormat="MMMM dd, yyyy"
                        onChange={setStartDate}
                        value={startDate}
                        openToDate={startDate}
                        showCalendarIcon={true}
                        includeDateIntervals={[{ start: this.props.minimumDate, end: this.props.maximumDate }]}
                        locale={selectedLanguage}
                    />
                </div>
            </div>
            <div className="w-full lg:w-1/4">
                <CTAButton open_in_same_tab={true} link={this.link} color="#fff" bgcolor="#333" type="primary" text={translations.searchButton} icon={<Icon className="w-6 h-4" icon="ArrowRight" />} />
            </div>
        </div>
        </>
    }
}

type TuruSearchWidgetSeasonPassProps = {
    selectedLanguage: string;
    defaultLanguage: string
}

class TuruSearchWidgetSeasonPass extends React.Component<TuruSearchWidgetSeasonPassProps> {
    get link() {
        const spSlug = "earlybird";
        let link = '/';
        if(this.props.defaultLanguage !== this.props.selectedLanguage) link += `${this.props.selectedLanguage}/`
        link += `${spSlug}`;
        return link;
    }

    render() {
        const translations = getSearchWidgetTranslations(this.props.selectedLanguage);

        return <>
        <div className={`bg-white flex flex-col lg:flex-row gap-4 justify-between items-center p-4 sm:p-6 rounded-b-2xl`}>
            <div className="w-full lg:flex py-3.5">
                Her finner du sesongkort for vinteren 2023 / 2024
            </div>
            <div className="w-full lg:w-1/4">
                <CTAButton open_in_same_tab={true} link={this.link} color="#fff" bgcolor="#333" type="primary" text={translations.searchButton} icon={<Icon className="w-6 h-4" icon="ArrowRight" />} />
            </div>
        </div>
        </>
    }
}


type SearchWidgetProps = {
    selectedLanguage: string;
    defaultLanguage: string;
    removeMargin: boolean;
}

type SearchWidgetState = {
    tab: "lodging" | "activities" | "lift-tickets" | "season-pass" | "eiendom",
    startDate: Date;
    endDate: Date;
    numdays: number;
}

export default class TuruSearchWidget extends React.Component<SearchWidgetProps, SearchWidgetState> {
    static minimumDate() {
        const baseDate = new Date();
        const hour = baseDate.getHours();
        const today = DateTime.fromJSDate(baseDate).startOf("day").toJSDate();
        const tomorrow = DateTime.fromJSDate(baseDate).startOf("day").plus({ day: 1 }).startOf("day").toJSDate();
        const minimumStart = hour >= 15 ? tomorrow : today;
        return minimumStart;
    }

    static getEndDate() {
        return DateTime.fromJSDate(TuruSearchWidget.minimumDate()).plus({day: 1}).toJSDate()
    }

    static minimumLTDate() {
        const baseDate = new Date('2024-01-01');
        const hour = baseDate.getHours();
        const today = DateTime.fromJSDate(baseDate).startOf("day").toJSDate();
        const tomorrow = DateTime.fromJSDate(baseDate).startOf("day").plus({ day: 1 }).startOf("day").toJSDate();
        const minimumStart = hour >= 15 ? tomorrow : today;
        return minimumStart;
    }

    static maximumDate() {
        const baseDate = new Date();
        const nextYears = DateTime.fromJSDate(baseDate).startOf("day").plus({ year: 2 }).startOf("day").toJSDate();
        return nextYears;
    }

    static maximumLTDate() {
        const baseDate = new Date('2024-04-14');
        return baseDate;
    }

    state: SearchWidgetState = {
        tab: "lodging",
        startDate: TuruSearchWidget.minimumDate(),
        endDate: TuruSearchWidget.getEndDate(),
        numdays: 1,
    }

    setActiveTab = (tab: any) => {
        this.setState({tab});
    }

    setNumDays = (days: number) => {
        this.setState({numdays: days});
    }

    setStartDate = (date: Date) => {
        const ts = date.getTime();
        const ets = this.state.endDate.getTime();
        if (ts > ets) {
            const plus1 = DateTime.fromJSDate(date).plus({day: 1}).toJSDate()
            this.setState({startDate: date, endDate: plus1});
        } else {
            this.setState({startDate: date});
        }
    }

    setEndDate = (date: Date) => {
        this.setState({endDate: date});
    }

    render() {
        const translations = getSearchWidgetTranslations(this.props.selectedLanguage);

        return <>
        <div className={`${this.props.removeMargin ? "" : "mt-[-90px]"} flex w-full justify-center px-6 lg:px-10 relative z-[2] flex-col`} style={{ filter: "drop-shadow(0px 2px 15px rgba(37, 37, 39, 0.15))" }}>
            <div className="w-full sm:max-w-6xl lg:max-w-7xl justify-center m-auto flex flex-col">
                <TuruSearchWidgetTabs activeTab={this.state.tab} setActiveTab={this.setActiveTab} translations={translations}/>

                {this.state.tab === 'lodging' ? <TuruSearchWidgetLodging
                    startDate={this.state.startDate}
                    setStartDate={this.setStartDate}
                    endDate={this.state.endDate}
                    setEndDate={this.setEndDate}
                    minimumDate={TuruSearchWidget.minimumDate()}
                    maximumDate={TuruSearchWidget.maximumDate()}
                    selectedLanguage={this.props.selectedLanguage}
                    defaultLanguage={this.props.defaultLanguage}
                     /> : null}
                {this.state.tab === 'lift-tickets' ? <TuruSearchWidgetLiftTickets
                    startDate={this.state.startDate > TuruSearchWidget.minimumLTDate() ? this.state.startDate : TuruSearchWidget.minimumLTDate()}
                    setStartDate={this.setStartDate}
                    minimumDate={TuruSearchWidget.minimumLTDate()}
                    maximumDate={TuruSearchWidget.maximumLTDate()}
                    selectedLanguage={this.props.selectedLanguage}
                    defaultLanguage={this.props.defaultLanguage}
                    /> : null}
                {this.state.tab === 'season-pass' ? <TuruSearchWidgetSeasonPass
                    selectedLanguage={this.props.selectedLanguage}
                    defaultLanguage={this.props.defaultLanguage}
                    /> : null}
                {this.state.tab === 'eiendom' ? <TuruSearchWidgetEiendom
                    selectedLanguage={this.props.selectedLanguage}
                    defaultLanguage={this.props.defaultLanguage}
                    /> : null}
            </div>
        </div>
        </>
    }

}